<template>
<div :class="{btn: true, alternate: isAlt}">
  <div class="trigger">
    <a :href="href" target="_blank" :data-closer="data_closer"><slot></slot></a>
    <div :class="{bg: true, alternate: isAlt}"></div>
  </div>
  <!--<div class="bg bg1"></div>-->
</div>
</template>

<script>
export default {
  name: 'Button',
  props: ['href', 'alternate', 'data_closer'],
  computed: {
    isAlt() {
      if (this.alternate) return true;
      return false;
    },
  },
};
</script>

<style lang="scss">
.btn {
  border: 2px solid #0076D1;
  background: linear-gradient(to bottom right, darken(#1880CF, 5), darken(#2D8BD4, 5));
  transition: all .2s ease;
  box-shadow: 0 3px 6px rgba(#000, .35);
  width: 100%;
  position: relative;
  text-align: center;
  border-radius: 2px;
  cursor: pointer;
  &.alternate {
    background: linear-gradient(to bottom right, darken($dark_bg, 10), darken($dark_bg, 5));
    border: 2px solid #222222;
  }
  a {
    display: inline-block;
    position: relative;
    text-decoration: none;
    color: #fff;
    padding: 10px 0;
    width: 100%;
    z-index: 11;
    background: transparent;
  }
  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to bottom right, #1880CF, #2D8BD4);
    transition: all .2s ease;
    z-index: 10;
    transform: scaleX(1);
    &.alternate {
      background: linear-gradient(to bottom right, $dark_bg, lighten($dark_bg, 5));
    }
  }
  .trigger {
    width: 100%;
    height: 100%;
    &:hover {
      .bg {
        //opacity: 0;
        transform: scaleX(0);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Button.vue